import { ClipboardText, Package, FilePdf } from "@phosphor-icons/react";
import { openAuthFile } from "../../lib/fileOpen";

const every = (d) => (!d ? "as required" : d % 365 === 0 ? `every ${d / 365} yr${d / 365 > 1 ? "s" : ""}` : d % 30 === 0 && d >= 60 ? `every ${d / 30} months` : d === 7 ? "weekly" : d === 30 ? "monthly" : d === 91 ? "quarterly" : d === 182 ? "6-monthly" : `every ${d} days`);

export function AssetPlanCard({ a }) {
  const tasks = a.service_tasks || [], parts = a.recommended_parts || [];
  if (!tasks.length && !parts.length && !a.manual_file_id) return null;
  return (
    <div className="rounded-lg border border-border bg-card p-4" data-testid="asset-plan-card">
      <div className="flex items-center justify-between gap-2 mb-3">
        <h3 className="font-semibold flex items-center gap-2"><ClipboardText size={16} /> Service plan &amp; spares</h3>
        {a.manual_file_id && <button onClick={() => openAuthFile(`/files/${a.manual_file_id}/preview`)} className="inline-flex items-center gap-1 text-xs text-primary hover:underline" data-testid="asset-manual-link"><FilePdf size={14} /> {a.manual_file_name || "O&M manual"}</button>}
      </div>
      <div className="grid md:grid-cols-2 gap-4 text-sm">
        <div>
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1.5">Planned tasks</p>
          {tasks.length === 0 ? <p className="text-xs text-muted-foreground">None recorded</p> : (
            <ul className="space-y-1.5" data-testid="asset-plan-tasks">
              {tasks.map((t, i) => <li key={i} className="rounded-md border border-border px-2.5 py-1.5"><div className="flex items-center justify-between gap-2"><span className="font-medium">{t.task}</span><span className="text-[11px] text-muted-foreground shrink-0">{every(t.interval_days)}</span></div>{t.notes && <p className="text-[11px] text-muted-foreground mt-0.5">{t.notes}</p>}</li>)}
            </ul>
          )}
        </div>
        <div>
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1.5 flex items-center gap-1"><Package size={12} /> Recommended spares</p>
          {parts.length === 0 ? <p className="text-xs text-muted-foreground">None recorded</p> : (
            <ul className="space-y-1.5" data-testid="asset-plan-parts">
              {parts.map((p, i) => <li key={i} className="flex items-center justify-between gap-2 rounded-md border border-border px-2.5 py-1.5"><span><span className="font-medium">{p.name}</span>{p.part_number && <span className="ml-1.5 font-mono text-[11px] text-muted-foreground">{p.part_number}</span>}</span><span className="text-[11px] text-muted-foreground shrink-0">×{p.quantity}{p.replace_interval_days ? ` · ${every(p.replace_interval_days)}` : ""}</span></li>)}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
